function IntroStep({ onBegin }) {
  return (
    <div className="landstar-step-content landstar-intro-layout">
      <div className="landstar-intro-card">
        <p className="landstar-kicker">Before You Begin</p>
        <h3>Your redemption happens in four quick steps</h3>
        <p className="landstar-intro-copy">
          Review the process below, then continue into the reward journey.
        </p>

        <ol className="landstar-intro-list">
          <li>
            <strong>Start here.</strong> Review the steps before entering the journey.
          </li>
          <li>
            <strong>Enter your driver code.</strong> The system will validate your eligibility.
          </li>
          <li>
            <strong>Select the reward.</strong> Choose the item, size, and color available for your tier.
          </li>
          <li>
            <strong>Confirm shipping.</strong> Review your details and submit the redemption request.
          </li>
        </ol>
        <br></br>
        <hr className="landstar-section-divider" />

        <div className="landstar-inline-actions landstar-inline-actions-start">
          <button type="button" className="landstar-primary-button" onClick={onBegin}>
            Start Redemption
          </button>
        </div>
      </div>
    </div>
  );
}

export default IntroStep;
